import { useLocalStorage } from '@Hooks/useStorage'
import { useMeQuery } from '@Store/api'

// WARNING: Do not remove ":" at the end
// it was set like this since the beginning: https://github.com/prisync/renaissance-fe/commit/a19d50edae5498699c203900d0f5a1a570343624#diff-63161fbd3054be7e069e9231cfad58f0ec958b0a7a53e228de693eca72f2ef13R2
// deleting will cause mismatch with the existing user's local storage data
export const ONBOARDING_STORAGE_KEY_PREFIX = 'renaissance:onboarding:'

function useStorageForOnboarding(): {
  isCompleted: boolean
  country?: any
  url?: any
  isApproveGDPR?: boolean
  companyId: string
  add: (key: string, value: any) => void
  set: (key: string, value: any) => Record<string, any>
  get: (key: string) => any
  remove: (key: string) => void
  clear: () => void
} | null {
  const onboardingStorage = useLocalStorage()

  const { data: meData, isSuccess } = useMeQuery()

  const id = meData?.id

  if (!isSuccess) {
    return null
  }

  return {
    isCompleted: meData?.is_onboarding_completed,
    country: meData?.country,
    url: meData?.url,
    isApproveGDPR: meData?.approve_gdpr || false,
    companyId: meData?.id,
    add: (key: string, value: any): void =>
      onboardingStorage.add(
        `${ONBOARDING_STORAGE_KEY_PREFIX}:${key}:${id}`,
        value,
      ),
    set: (key: string, value: any): Record<string, any> =>
      onboardingStorage.save(
        `${ONBOARDING_STORAGE_KEY_PREFIX}:${key}:${id}`,
        value,
      ),
    get: (key: string): any =>
      onboardingStorage.getSafe(`${ONBOARDING_STORAGE_KEY_PREFIX}:${key}:${id}`)
        ?.value,
    remove: (key: string): void => {
      onboardingStorage.remove(`${ONBOARDING_STORAGE_KEY_PREFIX}:${key}:${id}`)
    },
    clear: (): void => {
      for (const key of ['ob', 'onb', 'cs']) {
        onboardingStorage.remove(
          `${ONBOARDING_STORAGE_KEY_PREFIX}:${key}:${id}`,
        )
      }
    },
  }
}

export default useStorageForOnboarding
